import { useState, useCallback } from "react";
import { AppLayout } from "@/components/layout/AppLayout";
import AssetSchedule from "./AssetSchedule";

export default function Schedule() {
  const [headerActions, setHeaderActions] = useState<React.ReactNode>(null);
  const [titleSuffix, setTitleSuffix] = useState<string>("");
  const [titleExtra, setTitleExtra] = useState<React.ReactNode>(null);

  const handleActionsReady = useCallback((actions: React.ReactNode) => {
    setHeaderActions(actions);
  }, []);

  const handleTitleChange = useCallback((suffix: string) => {
    setTitleSuffix(suffix);
  }, []);

  const handleTitleExtraReady = useCallback((extra: React.ReactNode) => {
    setTitleExtra(extra);
  }, []);

  return (
    <AppLayout
      title="Schedule"
      actions={headerActions}
      titleExtra={
        <div className="flex items-center gap-2">
          {titleSuffix && (
            <span className="text-xl font-semibold text-muted-foreground">
              {titleSuffix}
            </span>
          )}
          {titleExtra}
        </div>
      }
    >
      <div className="space-y-4 -mt-6">
        <AssetSchedule
          embedded
          onActionsReady={handleActionsReady}
          onTitleChange={handleTitleChange}
          onTitleExtraReady={handleTitleExtraReady}
        />
      </div>
    </AppLayout>
  );
}
